export default "__VITE_ASSET__BOnixw6M__"